// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const Statuses = t.list(KeyValuePair, 'Statuses');

export const getDefaultState = () => new Statuses([]);

export default Statuses;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/state/statuses.js